import { setSessionItem, getSessionItem } from '@/utils/storage'
const order = {
    namespaced: true,
    state: {
        ORDERINFO: getSessionItem('ORDERINFO'),
        channelcode: getSessionItem('channelcode'),
    },
    mutations: {
        REMOVE_INFOBANK(state, bank) {
            state.ORDERINFO = null;
            setSessionItem('ORDERINFO', state.ORDERINFO)
        },
        SET_INFOAMT(state, amt) {
            state.ORDERINFO = { ...state.ORDERINFO, amt };
            setSessionItem('ORDERINFO', state.ORDERINFO)
        },
        SET_INFOBANK(state, bank) {
            state.ORDERINFO = { ...state.ORDERINFO, bank };
            setSessionItem('ORDERINFO', state.ORDERINFO)
        },
        SET_channelcode(state, channelcode) {
            state.channelcode = channelcode;
            setSessionItem('channelcode', state.channelcode)
        }

    },
    actions: {

    }
}

export default order



// WEBPACK FOOTER //
// ./src/store/modules/order.js